import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useAllocationStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function AllocationGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function AllocationGridLayout() {
  return <GridProvider store={useAllocationStore()}>
    <AllocationGrid />
  </GridProvider>
}
